import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import Badge from '../assets/images/Begin-Badge.png';
import HomeIcon from '../assets/icons/home.svg';
import CalendarIcon from '../assets/icons/calendar.svg';
import ProgramIcon from '../assets/icons/program.svg';
import ChartIcon from '../assets/icons/chart.svg';
import TrophyIcon from '../assets/icons/trophy.svg';
import NotificationIcon from '../assets/icons/notification.svg';
import SettingsIcon from '../assets/icons/settings.svg';
import ClubIcon from '../assets/icons/clipboard.svg';
import LogoutIcon from '../assets/icons/logout.svg';

function DashboardSidebar({ userId, user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  const isClubActive = location.pathname.includes(`/${userId}/club/`);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false); // Close menu when navigation happens
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('[DashboardSidebar] Error signing out:', error);
    }
  };

  return (
    <>
      {/* Hamburger Button - Mobile Only */}
      <button 
        className="dashboard-hamburger"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <div className={`dashboard-hamburger-icon ${isMenuOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {/* Overlay - Mobile Only */}
      {isMenuOpen && (
        <div 
          className="dashboard-sidebar-overlay"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`dashboard-sidebar ${isMenuOpen ? 'open' : ''}`}>
        <div className="dashboard-sidebar-profile">
          <img 
            src={user?.profilePictureUrl || Badge} 
            alt="Profile" 
            className="dashboard-profile-pic"
          />
        </div>
        <div className="dashboard-sidebar-icons">
          {/* Home - Dashboard */}
          <div 
            className={`dashboard-sidebar-icon ${isActive(`/${userId}/dashboard`) ? 'active' : ''}`}
            onClick={() => handleNavigation(`/${userId}/dashboard`)}
            data-tooltip="Home"
          >
            <img src={HomeIcon} alt="Home" />
          </div>
          
          {/* Calendar */}
          <div 
            className={`dashboard-sidebar-icon ${isActive(`/${userId}/calendar`) ? 'active' : ''}`}
            onClick={() => handleNavigation(`/${userId}/calendar`)}
            data-tooltip="Calendar"
          >
            <img src={CalendarIcon} alt="Calendar" />
          </div>
          
          {/* Program */}
          <div 
            className={`dashboard-sidebar-icon ${isActive(`/${userId}/program`) ? 'active' : ''}`}
            onClick={() => handleNavigation(`/${userId}/program`)}
            data-tooltip="Program"
          >
            <img src={ProgramIcon} alt="Program" />
          </div>
          
          {/* Performance / Chart */}
          <div 
            className={`dashboard-sidebar-icon ${isActive(`/${userId}/performance`) ? 'active' : ''}`}
            onClick={() => handleNavigation(`/${userId}/performance`)}
            data-tooltip="Performance"
          >
            <img src={ChartIcon} alt="Performance" />
          </div>
          
          {/* Awards / Trophy */}
          <div 
            className={`dashboard-sidebar-icon ${isActive(`/${userId}/awards`) ? 'active' : ''}`}
            onClick={() => handleNavigation(`/${userId}/awards`)}
            data-tooltip="Awards"
          >
            <img src={TrophyIcon} alt="Awards" />
          </div>

          {/* Club (club owners only) */}
          {user?.ownedClubIds?.length > 0 && (
            <div 
              className={`dashboard-sidebar-icon ${isClubActive ? 'active' : ''}`}
              onClick={() => handleNavigation(`/${userId}/club/${user.ownedClubIds[0]}`)}
              data-tooltip="Club"
            >
              <img src={ClubIcon} alt="Club" />
            </div>
          )}
          
          {/* Notifications */}
          <div 
            className={`dashboard-sidebar-icon ${isActive(`/${userId}/notifications`) ? 'active' : ''}`}
            onClick={() => handleNavigation(`/${userId}/notifications`)}
            data-tooltip="Notifications"
          >
            <img src={NotificationIcon} alt="Notifications" />
          </div>
          
          {/* Settings */}
          <div 
            className={`dashboard-sidebar-icon ${isActive(`/${userId}/settings`) ? 'active' : ''}`}
            onClick={() => handleNavigation(`/${userId}/settings`)}
            data-tooltip="Settings"
          >
            <img src={SettingsIcon} alt="Settings" />
          </div>
          
          {/* Logout */}
          <div 
            className="dashboard-sidebar-icon dashboard-sidebar-logout"
            onClick={handleLogout}
            data-tooltip="Log Out"
          >
            <img src={LogoutIcon} alt="Log Out" />
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardSidebar;



